import { InvalidAttributeUsageError, InvalidAttributeUsageJSONError } from '../../../errors';
export var AttributeUsageModel;
(function (AttributeUsageModel) {
    AttributeUsageModel[AttributeUsageModel["ContractHash"] = 0] = "ContractHash";
    AttributeUsageModel[AttributeUsageModel["ECDH02"] = 2] = "ECDH02";
    AttributeUsageModel[AttributeUsageModel["ECDH03"] = 3] = "ECDH03";
    AttributeUsageModel[AttributeUsageModel["Script"] = 32] = "Script";
    AttributeUsageModel[AttributeUsageModel["Vote"] = 48] = "Vote";
    AttributeUsageModel[AttributeUsageModel["DescriptionUrl"] = 129] = "DescriptionUrl";
    AttributeUsageModel[AttributeUsageModel["Description"] = 144] = "Description";
    AttributeUsageModel[AttributeUsageModel["Hash1"] = 161] = "Hash1";
    AttributeUsageModel[AttributeUsageModel["Hash2"] = 162] = "Hash2";
    AttributeUsageModel[AttributeUsageModel["Hash3"] = 163] = "Hash3";
    AttributeUsageModel[AttributeUsageModel["Hash4"] = 164] = "Hash4";
    AttributeUsageModel[AttributeUsageModel["Hash5"] = 165] = "Hash5";
    AttributeUsageModel[AttributeUsageModel["Hash6"] = 166] = "Hash6";
    AttributeUsageModel[AttributeUsageModel["Hash7"] = 167] = "Hash7";
    AttributeUsageModel[AttributeUsageModel["Hash8"] = 168] = "Hash8";
    AttributeUsageModel[AttributeUsageModel["Hash9"] = 169] = "Hash9";
    AttributeUsageModel[AttributeUsageModel["Hash10"] = 170] = "Hash10";
    AttributeUsageModel[AttributeUsageModel["Hash11"] = 171] = "Hash11";
    AttributeUsageModel[AttributeUsageModel["Hash12"] = 172] = "Hash12";
    AttributeUsageModel[AttributeUsageModel["Hash13"] = 173] = "Hash13";
    AttributeUsageModel[AttributeUsageModel["Hash14"] = 174] = "Hash14";
    AttributeUsageModel[AttributeUsageModel["Hash15"] = 175] = "Hash15";
    AttributeUsageModel[AttributeUsageModel["Remark"] = 240] = "Remark";
    AttributeUsageModel[AttributeUsageModel["Remark1"] = 241] = "Remark1";
    AttributeUsageModel[AttributeUsageModel["Remark2"] = 242] = "Remark2";
    AttributeUsageModel[AttributeUsageModel["Remark3"] = 243] = "Remark3";
    AttributeUsageModel[AttributeUsageModel["Remark4"] = 244] = "Remark4";
    AttributeUsageModel[AttributeUsageModel["Remark5"] = 245] = "Remark5";
    AttributeUsageModel[AttributeUsageModel["Remark6"] = 246] = "Remark6";
    AttributeUsageModel[AttributeUsageModel["Remark7"] = 247] = "Remark7";
    AttributeUsageModel[AttributeUsageModel["Remark8"] = 248] = "Remark8";
    AttributeUsageModel[AttributeUsageModel["Remark9"] = 249] = "Remark9";
    AttributeUsageModel[AttributeUsageModel["Remark10"] = 250] = "Remark10";
    AttributeUsageModel[AttributeUsageModel["Remark11"] = 251] = "Remark11";
    AttributeUsageModel[AttributeUsageModel["Remark12"] = 252] = "Remark12";
    AttributeUsageModel[AttributeUsageModel["Remark13"] = 253] = "Remark13";
    AttributeUsageModel[AttributeUsageModel["Remark14"] = 254] = "Remark14";
    AttributeUsageModel[AttributeUsageModel["Remark15"] = 255] = "Remark15";
})(AttributeUsageModel || (AttributeUsageModel = {}));
const isAttributeUsage = (value) => AttributeUsageModel[value] !== undefined;
export const assertAttributeUsage = (value) => {
    if (isAttributeUsage(value)) {
        return value;
    }
    throw new InvalidAttributeUsageError(value);
};
export const toJSONAttributeUsage = (usage) => assertAttributeUsageJSON(AttributeUsageModel[usage]);
export const isAttributeUsageJSON = (usage) => AttributeUsageModel[usage] !== undefined;
export const assertAttributeUsageJSON = (usage) => {
    if (isAttributeUsageJSON(usage)) {
        return usage;
    }
    throw new InvalidAttributeUsageJSONError(usage);
};
export const toAttributeUsage = (usage) => assertAttributeUsage(AttributeUsageModel[usage]);

//# sourceMappingURL=AttributeUsageModel.js.map
